import io from 'socket.io-client4';
import EventBus from "@/utils/EventBus";
import Vue from 'vue'
import store from '../store/index'
import virtualWaitingRoom from "vuex-store/modules/virtualWaitingRoom";
class SocketioService {
  socket;
  constructor() {}

  setupSocketConnection(user, token) {
    let bearerToken = `Bearer ${token}`
    let url = process.env.VUE_APP_VIRTUAL_WAITING_ROOM_URL
    if (process.env.VUE_APP_ENVIRONMENT !== 'local') {
      url = url.replace("/virtual-waiting-room", "")
    }
    this.socket = io(url, {
      path: "/vwr.io",
      extraHeaders: {
        jwt: bearerToken
      }
    })

    this.socket.on('connect', () => {
      EventBus.$emit('virtual-waiting-room-socket-connected')
    })
    this.socket.on('rate-request-after-end', (request) => {
      EventBus.$emit('rate-request-after-end', request)
      store.commit(`virtualWaitingRoom/RESET_ACTIVE_REQUEST`)
    })
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  listenOnlineUsers() {
    this.socket.on('online-users-updated', (data) => {
      store.dispatch('virtualWaitingRoom/setOnlineAudiologists', data)
      EventBus.$emit('online-users-updated', data)
    })
  }

  getQueue(userId) {
    this.socket.emit('queue-requests', {"userId": userId})
    this.socket.on('queue-requests', (requests) => {
      store.dispatch('virtualWaitingRoom/setRequests', requests)
    })
  }

  getActiveRequest() {
    this.socket.emit('active-request')
    this.socket.on('active-request', (request) => {
      store.commit(`virtualWaitingRoom/SET_ACTIVE_REQUEST`, {request})
    })
  }

  getMetrics(userId) {
    this.socket.emit('metrics', {"userId": userId})
    this.socket.on('metrics-updated', (metrics) => store.commit(`virtualWaitingRoom/UPDATE_METRICS`, {metrics}))
  }
  /*SET_REQUESTS = (state, { requests }) => {
    state.requests = requests.map((request, index) => {
      return {
        ...request,
        positionInQueue: index + 1
      }
    })
  }*/

  emitRequestOpened(requestId) {
    this.socket.emit('request-opened', {"requestId": requestId})
  }
  emitResetRequestOpened(requestId) {
    this.socket.emit('reset-request-opened', {"requestId": requestId})
  }


}

export default new SocketioService();
